/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateAccountWithSsoRequest,
  SetQuizUserInfoReq,
  SuccessBodyAuthResWithPlanType,
  SuccessBodyCountryCodeRes,
  SuccessBodyGetAuthProfileResponse,
  SuccessBodyGetUserAuthInfoResponse,
  SuccessBodyString,
  SuccessBodyTokenExchangeRes
} from '.././_model';

import { httpsInstance } from '../../httpClient';
import type { ErrorType , BodyType } from '../../httpClient';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * 
            온보딩 완료 후 Quiz User를 생성합니다.

            ### 호출 조건:
            - exchange-token API에서 needsOnboarding=true 응답을 받은 경우
            - 온보딩 페이지에서 memberType 및 추가정보 입력 완료 후

            ### Process Flow:
            1. Cookie(`ZEP_EXCHANGE_TOKEN`)에서 SSO Token 추출
            2. SSO Token 검증 및 사용자 정보 추출 (naturalUserId, email)
            3. Quiz User 생성 (ssoSubject = naturalUserId)
            4. Auth Server에 ServiceMapping 등록
            5. Quiz JWT 발급

            ### Cookie Settings:
            - **Name**: `ZEP_EXCHANGE_TOKEN`
            - **Domain**: `.zep.us`
            - **TTL**: 5분
        
 * @summary SSO 회원가입 (온보딩 완료)
 */
export const signup = (
    setQuizUserInfoReq: BodyType<SetQuizUserInfoReq>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyTokenExchangeRes>(
      {url: `/users/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setQuizUserInfoReq, signal
    },
      options);
    }
  


export const getSignupMutationOptions = <TError = ErrorType<SuccessBodyTokenExchangeRes>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: BodyType<SetQuizUserInfoReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: BodyType<SetQuizUserInfoReq>}, TContext> => {

const mutationKey = ['signup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signup>>, {data: BodyType<SetQuizUserInfoReq>}> = (props) => {
          const {data} = props ?? {};

          return  signup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignupMutationResult = NonNullable<Awaited<ReturnType<typeof signup>>>
    export type SignupMutationBody = BodyType<SetQuizUserInfoReq>
    export type SignupMutationError = ErrorType<SuccessBodyTokenExchangeRes>

    /**
 * @summary SSO 회원가입 (온보딩 완료)
 */
export const useSignup = <TError = ErrorType<SuccessBodyTokenExchangeRes>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: BodyType<SetQuizUserInfoReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signup>>,
        TError,
        {data: BodyType<SetQuizUserInfoReq>},
        TContext
      > => {

      const mutationOptions = getSignupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * 
            Converts Auth Server JWT to Quiz Service JWT.

            ### Supported Token Types:
            - **Access Token** (type="access"): Standard Auth Server JWT
            - **SSO Exchange Token** (type="sso_exchange"): Short-lived token for Frontend-Mediated SSO flow

            ### Parameter Priority:
            1. **Cookie** (`ZEP_EXCHANGE_TOKEN`) - Primary

            ### Process Flow:
            1. Validate Auth Server JWT (from Cookie)
            2. Extract Natural User ID (subject)
            3. Find Quiz User (Email-based account integration)
            4. Quiz User 있으면: Quiz Service JWT 반환
            5. Quiz User 없으면: needsOnboarding=true 반환 (온보딩 필요)

            ### Response Cases:
            - **기존 사용자**: quizToken, userId, email, username 반환
            - **신규 사용자**: needsOnboarding=true, naturalUserId, email 반환 -> /users/signup API 호출 필요

            ### Cookie Settings:
            - **Name**: `ZEP_EXCHANGE_TOKEN`
            - **Value**: Auth Server JWT
            - **Set By**: Auth Server
        
 * @summary Auth Server JWT to Quiz Server JWT Exchange
 */
export const exchangeToken = (
    
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyTokenExchangeRes>(
      {url: `/auth/exchange-token`, method: 'POST', signal
    },
      options);
    }
  


export const getExchangeTokenMutationOptions = <TError = ErrorType<SuccessBodyTokenExchangeRes>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,void, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,void, TContext> => {

const mutationKey = ['exchangeToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exchangeToken>>, void> = () => {
          

          return  exchangeToken(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExchangeTokenMutationResult = NonNullable<Awaited<ReturnType<typeof exchangeToken>>>
    
    export type ExchangeTokenMutationError = ErrorType<SuccessBodyTokenExchangeRes>

    /**
 * @summary Auth Server JWT to Quiz Server JWT Exchange
 */
export const useExchangeToken = <TError = ErrorType<SuccessBodyTokenExchangeRes>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,void, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exchangeToken>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getExchangeTokenMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * 
            API called when user selects "Create new account" during SAML/SSO login.

            ### Parameter Priority:
            1. **Cookie** (`ZEP_LINKING_SESSION`) - Primary
            2. **Request Body** (`linkingSessionId`) - Fallback

            ### Process Flow:
            1. Validate Linking Session (from Cookie or Request Body)
            2. Create new Quiz User (email-based)
            3. Link account with Auth Server (validate-and-link)
            4. Issue and return Quiz JWT

            ### Cookie Settings:
            - **Name**: `ZEP_LINKING_SESSION`
            - **Value**: Linking Session ID (UUID)
            - **Set By**: Auth Server
        
 * @summary Create New Quiz Account with SSO
 */
export const createAccountWithSso = (
    createAccountWithSsoRequest: BodyType<CreateAccountWithSsoRequest>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyAuthResWithPlanType>(
      {url: `/auth/create-account-with-sso`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAccountWithSsoRequest, signal
    },
      options);
    }
  


export const getCreateAccountWithSsoMutationOptions = <TError = ErrorType<SuccessBodyAuthResWithPlanType>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountWithSso>>, TError,{data: BodyType<CreateAccountWithSsoRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccountWithSso>>, TError,{data: BodyType<CreateAccountWithSsoRequest>}, TContext> => {

const mutationKey = ['createAccountWithSso'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccountWithSso>>, {data: BodyType<CreateAccountWithSsoRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createAccountWithSso(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountWithSsoMutationResult = NonNullable<Awaited<ReturnType<typeof createAccountWithSso>>>
    export type CreateAccountWithSsoMutationBody = BodyType<CreateAccountWithSsoRequest>
    export type CreateAccountWithSsoMutationError = ErrorType<SuccessBodyAuthResWithPlanType>

    /**
 * @summary Create New Quiz Account with SSO
 */
export const useCreateAccountWithSso = <TError = ErrorType<SuccessBodyAuthResWithPlanType>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountWithSso>>, TError,{data: BodyType<CreateAccountWithSsoRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccountWithSso>>,
        TError,
        {data: BodyType<CreateAccountWithSsoRequest>},
        TContext
      > => {

      const mutationOptions = getCreateAccountWithSsoMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getIso = (
    
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyCountryCodeRes>(
      {url: `/utils/iso`, method: 'GET', signal
    },
      options);
    }
  

export const getGetIsoQueryKey = () => {
    return [`/utils/iso`] as const;
    }

    
export const getGetIsoQueryOptions = <TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIsoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIso>>> = ({ signal }) => getIso(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetIsoQueryResult = NonNullable<Awaited<ReturnType<typeof getIso>>>
export type GetIsoQueryError = ErrorType<unknown>


export function useGetIso<TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIso>>,
          TError,
          Awaited<ReturnType<typeof getIso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetIso<TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIso>>,
          TError,
          Awaited<ReturnType<typeof getIso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetIso<TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetIso<TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetIsoQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetIsoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIsoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIso>>> = ({ signal }) => getIso(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetIsoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getIso>>>
export type GetIsoSuspenseQueryError = ErrorType<unknown>


export function useGetIsoSuspense<TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetIsoSuspense<TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetIsoSuspense<TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetIsoSuspense<TData = Awaited<ReturnType<typeof getIso>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIso>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetIsoSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const healthCheck = (
    
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyString>(
      {url: `/hello`, method: 'GET', signal
    },
      options);
    }
  

export const getHealthCheckQueryKey = () => {
    return [`/hello`] as const;
    }

    
export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHealthCheckSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HealthCheckSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckSuspenseQueryError = ErrorType<unknown>


export function useHealthCheckSuspense<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthCheckSuspense<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthCheckSuspense<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHealthCheckSuspense<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHealthCheckSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @deprecated
 */
export const getUserAuthInfo = (
    
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyGetUserAuthInfoResponse>(
      {url: `/auth/user-info`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserAuthInfoQueryKey = () => {
    return [`/auth/user-info`] as const;
    }

    
export const getGetUserAuthInfoQueryOptions = <TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAuthInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAuthInfo>>> = ({ signal }) => getUserAuthInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserAuthInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAuthInfo>>>
export type GetUserAuthInfoQueryError = ErrorType<unknown>


export function useGetUserAuthInfo<TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAuthInfo>>,
          TError,
          Awaited<ReturnType<typeof getUserAuthInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserAuthInfo<TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAuthInfo>>,
          TError,
          Awaited<ReturnType<typeof getUserAuthInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserAuthInfo<TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @deprecated
 */

export function useGetUserAuthInfo<TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserAuthInfoQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUserAuthInfoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAuthInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAuthInfo>>> = ({ signal }) => getUserAuthInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserAuthInfoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAuthInfo>>>
export type GetUserAuthInfoSuspenseQueryError = ErrorType<unknown>


export function useGetUserAuthInfoSuspense<TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserAuthInfoSuspense<TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserAuthInfoSuspense<TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @deprecated
 */

export function useGetUserAuthInfoSuspense<TData = Awaited<ReturnType<typeof getUserAuthInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserAuthInfo>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserAuthInfoSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAuthProfile = (
    
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyGetAuthProfileResponse>(
      {url: `/auth/profile`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAuthProfileQueryKey = () => {
    return [`/auth/profile`] as const;
    }

    
export const getGetAuthProfileQueryOptions = <TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthProfile>>> = ({ signal }) => getAuthProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAuthProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthProfile>>>
export type GetAuthProfileQueryError = ErrorType<unknown>


export function useGetAuthProfile<TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthProfile>>,
          TError,
          Awaited<ReturnType<typeof getAuthProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAuthProfile<TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthProfile>>,
          TError,
          Awaited<ReturnType<typeof getAuthProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAuthProfile<TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAuthProfile<TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAuthProfileQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAuthProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthProfile>>> = ({ signal }) => getAuthProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAuthProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthProfile>>>
export type GetAuthProfileSuspenseQueryError = ErrorType<unknown>


export function useGetAuthProfileSuspense<TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAuthProfileSuspense<TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAuthProfileSuspense<TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAuthProfileSuspense<TData = Awaited<ReturnType<typeof getAuthProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthProfile>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAuthProfileSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



